/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ExtendedTooltip, theme } from "@nordcloud/gnui";
import { ToggleItemBox, Wrap } from "~/components";
import { getDisplayNameByActionType } from "~/views/plans/utils";
import { PlanEntity, SelectedPlanEntity } from "../../../../types";

type Props = {
  item: PlanEntity;
  isSelected: boolean;
  disabled: boolean;
  tooltip?: string;
  onMouseDown: (item: SelectedPlanEntity) => void;
};

export function ActionItemCheckbox({
  item,
  isSelected,
  disabled,
  tooltip,
  onMouseDown,
}: Props) {
  const { id, color = "", actionName, actionType, description, icon } = item;
  const displayName = getDisplayNameByActionType(actionName ?? "", actionType);

  return (
    <Wrap css={{ "& > div": { width: "100%" } }}>
      <ExtendedTooltip
        caption={tooltip}
        position="start"
        zIndex={theme.zindex.topoftheworld}
      >
        <ToggleItemBox
          isCheckbox
          isSelected={isSelected}
          disabled={disabled}
          item={{
            id,
            color,
            name: displayName,
            actionType,
            description,
            icon,
            onMouseDown: () => onMouseDown(item),
          }}
        />
      </ExtendedTooltip>
    </Wrap>
  );
}
